/**
 * Decides what a route shows for the current session: the screen, the loading screen while the
 * session or account is still being read, or a redirect. `access` comes from routes.js.
 * Returns { kind: 'render' } | { kind: 'boot' } | { kind: 'error' } | { kind: 'redirect', to }.
 */
const resolveRouteAccess = ({ access, sessionStatus, contextStatus, hasFinishedOnboarding, returnTo = '', next = '' }) => {
  if (access === 'open') {
    return { kind: 'render' };
  }

  if (sessionStatus === 'unknown') {
    return { kind: 'boot' };
  }

  const isSignedIn = sessionStatus === 'signedIn';

  if (access === 'public') {
    // `next` is where a sign-in started from; only paths inside the app are followed.
    const safeNext = next.startsWith('/') && !next.startsWith('//') ? next : '/';
    return isSignedIn ? { kind: 'redirect', to: safeNext } : { kind: 'render' };
  }

  if (!isSignedIn) {
    const query = returnTo && returnTo !== '/' ? `?next=${encodeURIComponent(returnTo)}` : '';
    return { kind: 'redirect', to: `/sign-in${query}` };
  }

  if (contextStatus === 'error') {
    return { kind: 'error' };
  }

  if (contextStatus !== 'ready') {
    return { kind: 'boot' };
  }

  if (access === 'onboarding') {
    return hasFinishedOnboarding ? { kind: 'redirect', to: '/' } : { kind: 'render' };
  }

  return hasFinishedOnboarding ? { kind: 'render' } : { kind: 'redirect', to: '/onboarding' };
};

export default resolveRouteAccess;
